<ng-template #cropperTemplate>
	<div class="bg-white rounded-2xl shadow-2xl w-full flex flex-col overflow-hidden" style="max-height: 85vh;">
		<!-- Header -->
		<div class="flex items-center justify-between px-6 py-4 border-b border-charcoal/10">
			<h3 class="text-lg font-bold text-charcoal">Crop Image</h3>
			<button (click)="close()" class="p-2 hover:bg-charcoal/5 rounded-lg transition-colors">
				<svg class="w-5 h-5 text-charcoal/50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
				</svg>
			</button>
		</div>

		<!-- Cropper -->
		<div class="flex-1 overflow-auto p-4 bg-charcoal/5 flex items-center justify-center min-h-[300px]">
			@if (!imageLoaded()) {
			<div class="flex items-center gap-3 text-charcoal/50">
				<svg class="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
					<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
					<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
				</svg>
				<span class="text-sm">Loading image...</span>
			</div>
			}

			@if (imageFile) {
			<image-cropper
				[imageFile]="imageFile"
				[maintainAspectRatio]="true"
				[aspectRatio]="aspectRatio"
				[resizeToWidth]="resizeToWidth"
				[resizeToHeight]="resizeToHeight"
				[output]="'blob'"
				[format]="format"
				(imageCropped)="onImageCropped($event)"
				(imageLoaded)="onImageLoaded()"
				(loadImageFailed)="onLoadImageFailed()"
			></image-cropper>
			}
		</div>

		<!-- Footer -->
		<div class="flex items-center justify-between px-6 py-4 border-t border-charcoal/10">
			<p class="text-xs text-charcoal/50">{{ resizeToWidth }}×{{ resizeToHeight }}px</p>
			<div class="flex items-center gap-3">
				<button (click)="close()" class="px-5 py-2.5 text-sm font-semibold text-charcoal bg-charcoal/5 rounded-lg hover:bg-charcoal/10 transition-colors">
					Cancel
				</button>
				<button (click)="applyCrop()" [disabled]="!croppedBlob" class="px-5 py-2.5 text-sm font-semibold text-white bg-primary rounded-lg hover:bg-primary/90 transition-colors disabled:opacity-50">
					Crop & Apply
				</button>
			</div>
		</div>
	</div>
</ng-template>
